define('plugin/membership/view/MembershipFilterItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Membership filter item view
     *
     * @class MembershipFilterItemView
     */
    return LayoutView.extend({

        template: '#membership_filter_item_view',
        ui: {
            input: ':input',
        },
        triggers: {
            'change @ui.input': 'filterChanged'
        },

        isChecked: function () {
            return this.ui.input.is(':checked');
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.apply(this), {
                'checked': this.getOption('checked'),
                'field': this.getOption('field')
            });
        },

        onAttach: function () {
            Backbone.Wreqr.radio.vent.trigger('membershipFilter', 'refresh');
        }

    });

});
